import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/subtypes/[subtypeId]/todo_templates/Page";

export const PATH = (subtypeId: number): string =>
	`/settings/subtypes/${subtypeId}/todo_templates`;

function Home() {
	return (
		<>
			<NskHead title="TODOテンプレート" />
			<Component />
		</>
	);
}

export default Home;
